<div [ngClass]="styleContainer">
  <button *ngFor="let btn of tempArray" mat-raised-button [ngClass]="styleButton" (click)="changeComponent(btn)">
    {{ btn | translate }}
  </button>
</div>
